import { render, staticRenderFns } from "./filterbar.vue?vue&type=template&id=4fbbbb28&scoped=true&"
import script from "./filterbar.vue?vue&type=script&lang=js&"
export * from "./filterbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbbb28",
  null
  
)

export default component.exports